<template>
  <a-modal
    :title="isAdd ? '添加房间' : '修改房间'"
    :visible="visible"
    :confirmLoading="submitting"
    okText="提交"
    cancelText="取消"
    destroyOnClose
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="$emit('update:visible', false)"
  >
    <a-form :form="form">
      <a-form-item label="房间号" v-bind="formItemLayout">
        <a-input
          placeholder="请输入"
          v-decorator="['houseCode', formItemConfig]"
        />
      </a-form-item>
      <a-form-item label="建筑面积" v-bind="formItemLayout">
        <a-input
          placeholder="请输入"
          addonAfter="㎡"
          v-decorator="['structureArea', {
            validateFirst: true,
            normalize: trimNormalizer,
            rules: [
              ...formItemConfig.rules,
              { validator: checkRatio }
            ]
          }]"
        />
      </a-form-item>
      <a-form-item label="是否自用" v-bind="formItemLayout">
        <a-switch
          checkedChildren="是"
          unCheckedChildren="否"
          v-decorator="['selfFlag', {
            initialValue: false,
            valuePropName: 'checked'
          }]"
        />
      </a-form-item>
      <a-form-item label="排序号" v-bind="formItemLayout">
        <a-input
          placeholder="请输入"
          v-decorator="['seqNum', {
            validateFirst: true,
            normalize: trimNormalizer,
            rules: [
              { max: 32, message: '最多只能输入32个字符' },
              { pattern: /^[0-9]*$/, message: '排序号只能填写数字' }
            ]
          }]"
        />
      </a-form-item>
      <a-form-item label="备注" v-bind="formItemLayout">
          <a-input
            type="textarea"
            placeholder="请输入"
            v-decorator="['remark', {
              normalize: trimNormalizer,
              rules: [
                {max: 255, message: '最多只能输入255个字符'}
              ]
            }]"
          />
        </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { investment } from '@/api'
import { trimNormalizer } from '@/utils/tools'
import { checkRatio } from '@/utils/validator'
import pick from 'lodash/pick'

export default {
  name: 'DialogAddRoom',

  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 }
    }
  },

  props: {
    visible: Boolean,
    deptId: String,
    current: Object
  },

  computed: {
    isAdd () {
      return !this.current.houseId
    }
  },

  watch: {
    async visible (newVal) {
      if (newVal && !this.isAdd) {
        await this.$nextTick()
        this.form.setFieldsValue(pick(this.current, ['houseCode', 'structureArea', 'selfFlag', 'seqNum', 'remark']))
      }
    }
  },

  data () {
    return {
      checkRatio,
      trimNormalizer,
      submitting: false,
      form: this.$form.createForm(this),
      formItemConfig: {
        validateFirst: true,
        normalize: trimNormalizer,
        rules: [
          { required: true, message: '请输入' },
          { max: 32, message: '最多只能输入32个字符' }
        ]
      }
    }
  },

  methods: {
    handleSubmit () {
      this.form.validateFields(async (err, values) => {
        if (err) return
        this.submitting = true
        let { code, msg } = this.isAdd ? await investment.addRoom({
          ...values,
          unitTreeCode: this.deptId
        }) : await investment.updateRoom({
          ...values,
          treeCode: this.current.treeCode
        })
        this.submitting = false
        if (code !== 0) return this.$message.error(msg)
        this.$message.success(this.isAdd ? '添加成功' : '修改成功')
        this.$emit('update:visible', false)
        this.$emit('submitted')
      })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
